import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconFractureFolderSizeS from './IconFractureFolder_size_s';

const props: CreateIconArguments = {
  l: IconFractureFolderSizeS,
  m: IconFractureFolderSizeS,
  s: IconFractureFolderSizeS,
  xs: IconFractureFolderSizeS,
  name: 'IconFractureFolder',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
